<template>
  <div v-if="$route.meta.customPage">
    <router-view></router-view>
  </div>
  <v-app v-else id="amui-app">
    <router-view></router-view>
    <clear-cache-modal />
    <notifications />
    <idle-ping v-if="isAuthenticated && idleEnabled" />
    <app-survey v-if="isAuthenticated" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { authrecheck } from '@/helpers/auth'
import ClearCacheModal from './components/Common/ClearCacheModal'
import IdlePing from 'Components/IdlePing'
import AppSurvey from './components/Common/AppSurvey.vue'

export default {
  components: {
    ClearCacheModal,
    IdlePing,
    AppSurvey,
  },
  data: () => ({
    snackbar: false,
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'banned']),
    idleEnabled () {
      return process.env.NODE_ENV !== 'production' && process.env.VUE_APP_IDLE_DISABLED === true
    },
  },
  methods: {
    ...mapActions(['initializeSession', 'reportError']),
    hideLCWindow () {
      if (window.webpackHotUpdate) {
        return
      }

      if (this.banned) {
        window.LC_API.hide_chat_window()
      }
    }
  },
  watch: {
    isAuthenticated () {
      if (!this.$route.meta.skipSession) {
        authrecheck()
      }
    },
  },
  async created () {
    if (this.$route.meta.skipSession) {
      return
    }
    try {
      await this.initializeSession()
      this.hideLCWindow()
      authrecheck()
    } catch (e) {
      this.reportError(e)
    }
  },
  async mounted () {
    await this.$nextTick()
    // Set id`s to Window scope, from .env file
    window.adroll_adv_id = process.env.VUE_APP_ADROLL_ADV_ID
    window.adroll_pix_id = process.env.VUE_APP_ADROLL_PIX_ID
  }
}
</script>

<style lang="scss">
  @import "~vue-notifyjs/themes/material";
  .notifications.vue-notifyjs {
    z-index: 1000;
  }
  .alert {
    margin-top: 55px;
  }
</style>
